export default "__VITE_ASSET__sphbDvZk__"